import { render, staticRenderFns } from "./AssignLineItemFundCitation.vue?vue&type=template&id=5678b8a0"
import script from "./AssignLineItemFundCitation.vue?vue&type=script&lang=js"
export * from "./AssignLineItemFundCitation.vue?vue&type=script&lang=js"
import style0 from "./AssignLineItemFundCitation.vue?vue&type=style&index=0&id=5678b8a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports